import(/* webpackMode: "eager" */ "/app/apps/frontend/src/assets/placeholder.png");
;
import(/* webpackMode: "eager", webpackExports: ["BackLink"] */ "/app/apps/frontend/src/components/BackLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CmsForm"] */ "/app/apps/frontend/src/components/Forms/CmsForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_supports-color@10.2.2__@playwright+test@1.64.1_@types+no_e50c66d1ce2f122ff7fec441d73fbfa0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_supports-color@10.2.2__@playwright+test@1.64.1_@types+no_e50c66d1ce2f122ff7fec441d73fbfa0/node_modules/next/dist/client/image-component.js");
